export enum Badge {
  contactedBadge = 'contacted',
  freshBadge = 'fresh',
  hotCarBadge = 'hot_car',
  priceDropBadge = 'price_drop',
  viewedBadge = 'viewed',
}
